import GET from "./GET";

const springyOpen = {
	type: "spring",
	stiffness: 1000,
	mass: 4.6,
	damping: 80,
};

const springyLight = {
	...springyOpen,
	mass: 1,
	damping: 50,
};

const softSpringy = {
	type: "spring",
	stiffness: 2500,
	mass: 7,
	damping: 100,
};

const springyClose = {
	type: "spring",
	stiffness: 4000,
	mass: 1,
	damping: 180,
};
const selectTranition = {
	type: "spring",
	stiffness: 2000,
	mass: 6,
	damping: 120,
};

const survey = GET("survey");

// const slick = {
//     type: 'spring',
//     stiffness: 800,
//     mass: 4,
//     damping: 90,
// }

// Framer Motion Animation rules

const transition = {
	type: "spring",
	stiffness: 1100,
	mass: 6,
	damping: 100,
};

const anim = {
	bubbleContainer: {
		initial: {},
		animate: {
			transition: {
				...springyOpen,
				// staggerChildren: 0.04,
			},
		},
	},
	bubbleTop: {
		initial: {
			y: -4,
		},
		animate: ({ scale, index }) => {
			return {
				y: 0,
				transition: {
					repeat: Infinity,
					repeatType: "mirror",
					duration: 0.6,
					ease: "easeInOut",
					delay: index / 10,
				},
			};
		},
	},
	bubbleBottom: {
		initial: {
			y: 4,
		},
		animate: ({ scale, index }) => {
			return {
				y: 0,
				transition: {
					repeat: Infinity,
					repeatType: "mirror",
					duration: 0.6,
					ease: "easeInOut",
					delay: index / 10,
				},
			};
		},
	},
	bubble: {
		initial: {
			scale: 0,
			opacity: 0,
			y: -100,
		},
		animate: ({ scale }) => {
			return { scale, opacity: 1, y: 0, transition: { duration: 0.3 } };
		},
	},
	card: {
		initial: {
			scale: 0,
			opacity: 0,
			y: -100,
			transition,
		},
		animate: {
			scale: 1,
			opacity: 1,
			y: 0,
			transition,
		},
	},
	item: {
		initial: {
			y: 20,
			opacity: 0,
		},
		animate: {
			y: 0,
			opacity: 1,
		},
		exit: {
			y: 20,
			opacity: 0,
		},
	},
	modalContainer: {
		initial: ({ identifier, length }) => {
			return {
				opacity: 0,
				scale: 0.94,
				// height: 0.8 * innerHeight
				// scaleY: 0.8,
				// scaleX: 0.9,
				// y: 15 * (length - identifier),
			};
		},
		animate: {
			y: 0,
			opacity: 1,
			scale: 1,
			scaleX: 1,
			scaleY: 1,
			height: "auto",
			transition: { ...springyClose, staggerChildren: 0.04 },
		},
		exit: {
			opacity: 0,
			// scale: 0.82,
			// y: -20,
		},
	},

	modalItem: {
		initial: {
			scale: 0.8,
			opacity: 0.4,
			y: 0,
		},
		animate: {
			scale: 1,
			opacity: 1,
			y: 0,
		},
		exit: {
			opacity: 0,
			scale: 0,
			y: 0,
		},
	},

	dialog: {
		initial: {
			opacity: 0,
			scale: 0.8,
			transition: {
				delayChildren: 0.15,
				staggerChildren: 0.04,
			},
		},

		animate: {
			opacity: 1,
			scale: 1,
			transition: {
				delayChildren: 0.15,
				staggerChildren: 0.04,
			},
		},

		exit: {
			opacity: 0,
			scale: 0.8,
			transition: {
				delay: 0.1,
				staggerChildren: 0.06,
			},
		},
	},

	dialogQuick: {
		initial: {
			opacity: 0,
			transition: {
				delayChildren: 0.15,
				staggerChildren: 0.04,
			},
		},

		animate: {
			opacity: 1,
			scale: 1,
			transition: {
				delayChildren: 0.15,
				staggerChildren: 0.04,
			},
		},

		exit: {
			opacity: 0,
			transition: {
				delay: 0.1,
				staggerChildren: 0.06,
			},
		},
	},

	dialogItem: {
		initial: {
			opacity: 0,
			scale: 0.8,
			y: -60,
		},

		animate: {
			opacity: 1,
			scale: 1,
			y: 0,
		},

		exit: {
			opacity: 0,
			scale: 0.8,
			y: 60,
		},
	},

	cardBody: {
		initial: {
			height: `${survey ? "0px" : "100%"}`,
			y: `${survey ? -50 : 0}`,
		},
		animate: {
			transition: {
				...springyOpen,
				delayChildren: 0.2,
				staggerChildren: 0.05,
			},
			height: "100%",
			y: 0,
			borderTop: "1px solid rgb(238, 238, 238)",
		},
		exit: {
			transition: survey ? springyClose : { type: "linear" },
			height: "0px",
			y: -50,
			padding: "0px",
			borderTop: "0px solid rgb(0, 0, 0)",
		},
	},
	cardOption: {
		initial: {
			y: 0,
			opacity: 0,
			scale: 0.94,
			x: 0,
		},
		animate: {
			y: 0,
			opacity: 1,
			scale: 1,
			x: 0,
		},
	},
	button: {
		initial: {
			transition: softSpringy,
			scale: 0,
		},
		animate: {
			transition: softSpringy,
			scale: 1,
		},
		exit: {
			transition: softSpringy,
			scale: 0,
		},
	},
	staticCard: {
		initial: {
			scale: 0,
		},
		animate: {
			scale: 1,
			transition: springyLight,
		},
		exit: {
			scale: 0,
		},
	},
	inputContainer: {
		initial: {
			scaleX: 0.6,
			x: 40,
			opacity: 0,
		},
		animate: {
			scaleX: 1,
			x: 0,
			opacity: 1,
			transition: springyOpen,
		},
		exit: {
			scaleX: 0.4,
			opacity: 0,
			x: 40,
		},
	},
	select: {
		initial: {
			y: -40,
			scale: 0.9,
			height: "0px",
			opacity: 0,
		},
		animate: {
			y: 0,
			scale: 1,
			height: "auto",
			opacity: 1,
			transition: {
				...selectTranition,
				staggerChildren: 0.07,
			},
		},

		exit: {
			y: -40,
			scale: 0.9,
			height: "0px",
			opacity: 0,
			transition: {
				...selectTranition,
				staggerChildren: 0.07,
				delay: 0.21,
			},
		},
	},
	pdp: {
		initial: {
			opacity: 0,
			y: 50,
		},

		animate: {
			opacity: 1,
			y: 0,
			transition: {
				delayChildren: 0.15,
				staggerChildren: 0.04,
			},
		},

		exit: {
			opacity: 0,
			y: 50,
		},
	},

	pdpItem: {
		initial: {
			opacity: 0,
			y: 40,
		},
		animate: {
			opacity: 1,
			y: 0,
		},
		exit: {
			opacity: 0,
			y: 10,
		},
	},
	surfaceManager: {
		initial: {
			opacity: 1,
		},
		animate: {
			opacity: 1,
			transition: {
				// delayChildren: 0.15,
				// staggerDirect: -1,
				// staggerChildren: 0.04,
			},
		},
		exit: {
			opacity: 0,
		},
	},
	rewardPoints: {
		initial: {
			y: 0,
			opacity: 0,
			scale: 0.2,
		},
		animate: {
			opacity: 1,
			y: -70,
			scale: 1,
			transition: { ...springyOpen, delay: 0.2 },
		},
		exit: {
			y: [-70, -90, 0],
			opacity: [1, 1, 0],
			scale: [1, 1.1, 0.2],
		},
	},
	rewardActionBar: {
		initial: {
			scale: 1,
		},
		animate: {
			scale: [1, 1.1, 1.1, 0.95, 1],
			transition: { type: "spring" },
		},
	},
};

export default anim;
